import React from 'react'
import { Review } from '@/types'
import { Card, CardHeader, CardContent } from '../../components/ui'
import styles from './styles.module.css';
import { Head } from '@inertiajs/react';
import ReferralBlock from '../../components/ReferralBlock'

interface CreateProps {
  review: Review
}

const Create: React.FC<CreateProps> = ({ review }) => {
  return (
    <div className={styles.container}>
      <Head>
        <title>Merci pour votre avis !</title>
      </Head>
      <Card className="w-full max-w-2xl">
        <CardHeader>
          <h1>
            Merci pour votre avis !
          </h1>
        </CardHeader>
        <CardContent>
          Votre avis a bien été enregistré et vous rend élligible à notre grand tirage au sort !
          <ReferralBlock token={review.token} />
        </CardContent>
      </Card>
    </div>
  )
}

export default Create;